import { useEffect, useState } from 'react';
import './team-view-content.styles.scss';
import { sortPlayers } from '@/utils/sortPlayers';
import { useLocation, useNavigate } from 'react-router-dom';
import ImageContainer from '@/components/SHARED/image-container/image-container.component';
import PlayerNameIcon from '@/components/PLAYER/player-blocks/components/status-elements/player-name-icon.component';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowRight } from '@fortawesome/free-solid-svg-icons';
import { getQueryFromFirestore } from '@/utils/getDataFromDbSimplified';
import { properCase } from '@/utils/properCase';
import { completeGameElementData } from '@/components/PREVIEW/previewGameElements';
import { useSelector } from 'react-redux';

const TeamViewContent = ({
  gameData,
  teamData,
  playerList,
  isManager
}) => {

  const screenSize = useSelector(state => state.contentData.screenSize);
  const [teamMemberList, setTeamMemberList] = useState([]);
  const [totalTeamPlayerPoints, setTotalTeamPlayerPoints] = useState(0);
  const [teamEarnedPoints, setTeamEarnedPoints] = useState(0);
  const [prereqElements, setPrereqElements] = useState([]);
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    if (!teamData || !playerList) return;
    setTeamEarnedPoints(teamData.points || 0);
    getPrereqElements();
    const membersArr = [];
    Object.values(playerList).forEach(p => {
      if (
        teamData.opt_members &&
        teamData.opt_members.includes(p.playerId)
      ) {
        membersArr.push(p);
      }
    });
    const sortedPlayers = sortPlayers({
      'playerList': membersArr,
      'filter': 'players'
    })
    setTeamMemberList(sortedPlayers);
    setTotalTeamPlayerPoints(
      sortedPlayers.reduce((total, p) => {
        return total + (p.points || 0)
      }, 0)
    )
  }, [teamData, playerList]);

  function getPrereqElements() {
    if (location.pathname.includes('/preview/')) {
      const elements = Object.values(completeGameElementData)
        .filter(e => {
          if (e.type === 'secretCode') return false;
          if (
            e.opt_prereqTeams &&
            e.opt_prereqTeams.includes(teamData.playerId) &&
            e.opt_visible &&
            e.status === 'active'
          ) return true;
          return false;
        });
      setPrereqElements(elements);
      return;
    }
    const queryArray = [
      {
        'field': 'opt_prereqTeams',
        'operator': 'array-contains',
        'value': teamData.playerId
      },
      {
        'field': 'status',
        'operator': '==',
        'value': 'active'
      },
      {
        'field': 'opt_visible',
        'operator': '==',
        'value': true
      },
    ];
    if (location.pathname.includes('/preview/player/') || location.pathname.includes('/play/')) {
      queryArray.push({
        'field': 'type',
        'operator': '!=',
        'value': 'secretCode'
      })
    }
    getQueryFromFirestore({
      'path': `games/${teamData.gameId}/gameElements`,
      'queryArray': queryArray,
      'callback': callback,
      'once': true
    })
    function callback(data) {
      let elements = [];
      Object.values(data).forEach(d => {
        if (
          d.dateOpen > new Date().getTime() ||
          d.dateClose < new Date().getTime()
        ) return
        elements.push(d);
      })
      setPrereqElements(elements);
    }
  }

  return (
    <div className={`team-view-content ${screenSize}`}>
      <div className='team-view-header'>
        <ImageContainer
          src={teamData.icon}
          className='team-icon' />
        <h2>{teamData.name}</h2>
        <div className='buttons'>
          {
            (location.pathname.includes('/preview/manager/') ||
              location.pathname.includes('/manage/')) &&
            <button
              className={`g-button med-btn ${isManager ? '' : 'disabled'}`}
              onClick={() => navigate(`edit`)} >
              Edit
            </button>

          }
        </div>
      </div>
      <div className='team-points g-list-item'>
        <h3>
          Total Member Points:
          <div className='team-point-amount'>
            <ImageContainer src="/images/xp_team.png" className="xp-icon" />
            {totalTeamPlayerPoints}
          </div>
        </h3>
        <h3>
          Team Points:
          <div className='team-point-amount'>
            <ImageContainer src="/images/team_points.png" className="xp-icon" />
            {teamEarnedPoints}
          </div>
        </h3>
      </div>
      <div className="g-space-1"></div>


      <div className='team-player-list  g-list-item'>
        <div className='team-member'>
          <div><h3>Team Members</h3></div>
          {
            (
              !location.pathname.includes('/preview/player/') &&
              !location.pathname.includes('/play/')
            ) &&
            <>
              <div className='member-points'>
                <ImageContainer src="/images/xp.png" className="xp-icon" />
              </div>
              <div className='member-points'>
                <ImageContainer src="/images/icons/coin.png" className="xp-icon" />
              </div>
              <div className='member-points'>
                <ImageContainer src="/images/icons/coins.png" className="xp-icon" />
              </div>
            </>
          }
          <div style={{ 'width': '32px' }}></div>
        </div>
        {
          (teamMemberList.length > 0)
            ?
            teamMemberList.map(m => {
              const playerInfo = playerList[m.playerId];
              return (
                <div key={m.playerId} className='team-member'>
                  <PlayerNameIcon
                    player={playerInfo}
                    reverse={true}
                    className='player-name-icon'
                    tinyIcon={screenSize === 'mobile'} />
                  {
                    (
                      !location.pathname.includes('/preview/player/') &&
                      !location.pathname.includes('/play/')
                    ) &&
                    <>
                      <div className='member-points'>
                        {playerInfo.points || 0}
                      </div>
                      <div className='member-points'>
                        {playerInfo.currency || 0}
                      </div>
                      <div className='member-points'>
                        {playerInfo.currencyTotal || 0}
                      </div>
                      <div className="buttons">
                        <button
                          className='g-button small-btn'
                          onClick={() => navigate(
                            location.pathname.includes('/preview/manager/')
                              ? `/preview/manager/${gameData.path}/players/${m.path}`
                              : `/manage/${gameData.path}/players/${m.path}`)}>
                          <FontAwesomeIcon icon={faArrowRight} />
                        </button>

                      </div>
                    </>
                  }
                </div>
              )
            })
            :
            <span>No members have been added to this team yet.</span>
        }
      </div>
      {
        (prereqElements.length > 0) &&
        <>
          <div className="g-space-1"></div>
          <div className='team-prereq-elements g-list-item'>
            <h3 className='prereq-element'><span className='title'>Team-Specific Elements</span></h3>
            {prereqElements.map(e => {
              return (
                <div key={e.id} className='prereq-element'>
                  <div className='prereq-image-title'>
                    <ImageContainer
                      src={e.icon}
                      className='prereq-element-icon'
                      containerHeight='50px'
                      containerWidth='50px'
                      preview={true} />
                    {e.name}
                  </div>
                  <div>{e.opt_itemType ? properCase(e.opt_itemType) + ' ' : ''}{properCase(e.type)}</div>
                  <div>
                    {
                      (
                        location.pathname.includes('/preview/manager/') ||
                        location.pathname.includes('/manage/') ||
                        e.type === 'challenge'
                      ) &&
                      <button
                        className='g-button small-btn'
                        onClick={() => navigate(
                          location.pathname.includes('/preview/manager/')
                            ? `/preview/manager/${gameData.path}/elements/${e.type}s/${e.path}`
                            : location.pathname.includes('/preview/player/')
                              ? `/preview/player/${gameData.path}/${e.type}s/${e.path}`
                              : location.pathname.includes(`/manage/${gameData.path}/`)
                                ? `/manage/${gameData.path}/elements/data/${e.path}`
                                : `/play/${gameData.path}/${e.type}s/${e.path}`
                        )}>
                        <FontAwesomeIcon icon={faArrowRight} />
                      </button>
                    }
                  </div>
                </div>
              )
            }
            )}
          </div>
        </>
      }
    </div>
  )
}

export default TeamViewContent